module.exports = __webpack_public_path__ + "img/listria_b1.799b5fae.jpg";